/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Foot_LinkInputs */

const en_cp_foot_link = /** @type {(inputs: Cp_Foot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Campus`)
};

const id_cp_foot_link = /** @type {(inputs: Cp_Foot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Campus`)
};

/**
* | output |
* | --- |
* | "Bystep Campus" |
*
* @param {Cp_Foot_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_foot_link = /** @type {((inputs?: Cp_Foot_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Foot_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_foot_link(inputs)
	return en_cp_foot_link(inputs)
});